import { IconMail } from '@tabler/icons-react';
import { getIn, useFormik } from 'formik';
import { Link } from 'react-router-dom';
import * as yup from 'yup';
import InlineError from '@components/forms/InlineError';
import useForgotPassword from '@hooks/auth/useForgotPassword';
import authBackgroundImage from '@assets/img/auth/bg-auth.webp';
import brandLogo from '@assets/img/brand/logo.png';

const forgotPasswordValidationSchema = yup.object({
  email: yup
    .string()
    .trim()
    .email('Enter a valid email.')
    .required('Email is required.'),
});

function ForgotPasswordPage() {
  const { sendRecoveryEmail, isSubmitting, error, success } = useForgotPassword();
  const formik = useFormik({
    initialValues: {
      email: '',
    },
    validationSchema: forgotPasswordValidationSchema,
    validateOnMount: true,
    onSubmit: async (values) => {
      await sendRecoveryEmail(values.email);
    },
  });

  function getFieldError(path) {
    const touched = getIn(formik.touched, path);
    const fieldError = getIn(formik.errors, path);
    return touched ? fieldError || '' : '';
  }

  async function handleSubmit(event) {
    event.preventDefault();
    formik.setTouched(
      {
        email: true,
      },
      true,
    );
    await formik.submitForm();
  }

  return (
    <main
      className="auth-page auth-page--login"
      style={{ backgroundImage: `url(${authBackgroundImage})` }}
    >
      <section className="auth-card">
        <div className="auth-brand">
          <img className="auth-brand-logo" src={brandLogo} alt="Exploor CMS" />
        </div>
        <h1 className="auth-title">Recover Password</h1>
        <p className="auth-subtitle">Enter your email and we will send a recovery link.</p>
        <form className="form-grid auth-form-grid" onSubmit={handleSubmit}>
          <label className="field-label" htmlFor="email">
            <span className="auth-field-label">
              Email
              {getFieldError('email') ? (
                <InlineError>{getFieldError('email')}</InlineError>
              ) : null}
            </span>
            <span className="field-label app-form-field auth-form-field">
              <span className="auth-input-icon" aria-hidden="true">
                <IconMail size={18} />
              </span>
              <input
                className="field-input"
                id="email"
                name="email"
                type="email"
                autoComplete="email"
                value={formik.values.email}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                placeholder="Enter your email"
              />
            </span>
          </label>
          {error ? <p className="message-error">{error}</p> : null}
          {success ? <p className="message-ok">{success}</p> : null}
          <button
            className="button-primary auth-submit-btn"
            type="submit"
            disabled={isSubmitting || !formik.isValid}
          >
            {isSubmitting ? 'Sending...' : 'Send'}
          </button>
        </form>
        <div className="auth-links">
          <Link to="/login">Back to sign in</Link>
        </div>
      </section>
    </main>
  );
}

export default ForgotPasswordPage;
